export const STATUS = {
  submitted: { label: "Submitted", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  under_review: { label: "Under Review", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  in_progress: { label: "In Progress", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  rejected: { label: "Rejected", cls: "bg-[#FBEDEA] text-red-700 border-red-300" },
  new: { label: "New", cls: "bg-[#FBEDEA] text-red-700 border-red-300" },
  contacted: { label: "Contacted", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  quoted: { label: "Quoted", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  closed: { label: "Closed", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
};

export const REQUEST_STATUSES = ["submitted", "under_review", "in_progress", "completed", "rejected"];
export const ENQUIRY_STATUSES = ["new", "contacted", "quoted", "closed"];
export const TIMELINE_STEPS = ["submitted", "under_review", "in_progress", "completed"];

import { CATEGORIES } from "./products";

const d = (name, label, type = "text", options) => ({ name, label, type, options });

export const REQUEST_TYPES = {
  amc: {
    label: "AMC Request",
    icon: "CalendarCheck",
    blurb: "New contract, renewal or scope change for annual maintenance.",
    fields: [
      d("systems", "Systems to cover", "text"),
      d("sites", "Number of sites", "number"),
      d("frequency", "Visit frequency", "select", ["Quarterly", "Half-yearly", "Annual", "Not sure"]),
      d("contract_start", "Preferred start date", "date"),
      d("contract_kind", "Request kind", "select", ["New contract", "Renewal", "Scope change"]),
    ],
  },
  warranty: {
    label: "Warranty Claim",
    icon: "ShieldCheck",
    blurb: "Report a defect on equipment supplied or installed by Vinsafe.",
    fields: [
      d("product", "Product / equipment", "text"),
      d("serial_number", "Serial / batch number", "text"),
      d("invoice_number", "Invoice number", "text"),
      d("purchase_date", "Purchase / install date", "date"),
      d("issue_type", "Issue type", "select", ["Not working", "Pressure loss", "Physical damage", "False alarm", "Other"]),
    ],
  },
  new_order: {
    label: "New Order / Enquiry",
    icon: "PackagePlus",
    blurb: "Request quotation for products, refills or a new installation.",
    fields: [
      d("category", "Category", "select", [...CATEGORIES.map((c) => c.name), "Custom solution", "Mixed / Other"]),
      d("quantity", "Approx. quantity", "text"),
      d("required_by", "Required by", "date"),
    ],
  },
  service: {
    label: "Service / Safety Check",
    icon: "Wrench",
    blurb: "Book refilling, testing, repair, audit or a mock drill.",
    fields: [
      d("service_type", "Service type", "select", ["Refilling", "Hydro test", "System testing", "Repair / breakdown", "Fire safety audit", "Mock drill / training"]),
      d("preferred_date", "Preferred visit date", "date"),
      d("systems", "Systems involved", "text"),
    ],
  },
  other: {
    label: "General Support",
    icon: "LifeBuoy",
    blurb: "Doesn't fit the buckets above? Tell us and we'll route it.",
    fields: [d("topic", "What is this about?", "text")],
  },
};
